import { TemplatesTable } from "@/components/partial";

function AdminDocumentTemplates() {
  return <TemplatesTable />;
}

export default AdminDocumentTemplates;
